/**
 * Focus-ring element — shared :focus-visible outline tokens.
 * Source of truth: Pangea Galapagos UI Design System — Beta
 * https://www.figma.com/design/Orc6uUodQaoXep59CGaUNw
 */

import { spacing } from './spacing';
import { colors } from './colors';

export const focusRing = {
  width: spacing.xxs,
  offset: spacing.xxs,
  color: colors.button.primary,
} as const;

export type FocusRing = typeof focusRing;
